import React from 'react';
import { scoreColor } from './ReportBits';

const CAL = {
  Confirmed: 'text-emerald-700 bg-emerald-50 border-emerald-200',
  'Partially demonstrated': 'text-amber-700 bg-amber-50 border-amber-200',
  'Over-claimed': 'text-red-700 bg-red-50 border-red-200',
};

export const SkillGapPanel = ({ skills }) => (
  <section className="rounded-2xl border border-slate-200 bg-white p-6" data-testid="report-skill-gaps">
    <div className="flex items-baseline justify-between gap-4 mb-5">
      <h3 className="text-lg font-bold text-slate-900" style={{ fontFamily: 'Manrope, sans-serif' }}>Skill scores & improvement gap</h3>
      <span className="text-xs text-slate-500">Claimed confident → demonstrated</span>
    </div>
    <div className="space-y-4">
      {skills.map((s) => (
        <div key={s.id} data-testid={`skill-gap-${s.id}`}>
          <div className="flex flex-wrap items-center justify-between gap-2 mb-1.5">
            <div className="flex items-center gap-2 min-w-0">
              <span className="text-sm font-semibold text-slate-800 truncate">{s.name}</span>
              <span className={`text-[10px] font-semibold px-2 py-0.5 rounded-full border ${CAL[s.calibration]}`}>{s.calibration}</span>
            </div>
            <span className="text-xs text-slate-600">
              <b className="text-slate-900">{s.score}%</b> · needs <b style={{ color: scoreColor(100 - s.gap) }}>{s.gap}%</b> improvement
            </span>
          </div>
          <div className="h-2.5 rounded-full bg-slate-100 overflow-hidden flex">
            <div className="h-full rounded-full transition-[width] duration-1000" style={{ width: `${s.score}%`, background: scoreColor(s.score) }} />
          </div>
          <p className="text-[11px] text-slate-400 mt-1">{s.correct}/{s.items} items fully correct · {s.mode === 'hands_on' ? 'hands-on + scenario' : 'scenario-based'}</p>
        </div>
      ))}
    </div>
  </section>
);

export default SkillGapPanel;
